export default __webpack_public_path__ + "static/media/logo-img.57ff6db2.png";